module.exports = __webpack_public_path__ + "img/map_pc_8.4d2ffabc.png";